import shouldForwardProp from "@styled-system/should-forward-prop";
import {
  cursorProp,
  CursorProp,
  compose,
  space,
  layout,
  border,
  flexbox,
  position,
  typography,
  color,
  shadow,
  system,
  SpaceProps,
  LayoutProps,
  BorderProps,
  FlexboxProps,
  PositionProps,
  TypographyProps,
  ColorProps,
  ShadowProps,
  OverrideNativeElementProps,
} from "../../utils/styleFn";
import { styled, EmotionComponent } from "../../styled";
import { Box, BoxProps } from "../Box";

const customProps = system({
  flexFlow: true,
});

const styleProps = compose(
  cursorProp,
  space,
  layout,
  position,
  color,
  typography,
  shadow,
  border,
  flexbox,
  customProps
);

export type FlexProps = OverrideNativeElementProps<
  SpaceProps &
    CursorProp &
    FlexboxProps &
    LayoutProps &
    BorderProps &
    PositionProps &
    TypographyProps &
    ColorProps &
    ShadowProps,
  "div"
>;

export const Flex: EmotionComponent<BoxProps> = styled(Box, {
  shouldForwardProp,
})`
  display: flex;
  ${styleProps};
`;

Flex.displayName = "Flex";

export default Flex;
